module.exports = __webpack_public_path__ + "static/media/team_5.1ceffda4.jpg";